// import { BASE_API } from "../Config/Config";

// export const fetchorgchartaddapi = async (data, type) => {

//     try {
//         const userDetails = JSON.parse(sessionStorage.getItem("userdetails"));
//         const formData = new FormData();

//         formData.append("parent_id", data.parentId);
//         formData.append("created_by", userDetails?.id);
//         formData.append("ta_name", data.name_ta);
//         formData.append("en_name", data.name_en);
//         formData.append("type", type);
//         if (type === "managementOrgchart") {
//             formData.append("en_role", data.position_en);
//             formData.append("ta_role", data.position_ta);
//         }

//         const response = await fetch(
//             `${BASE_API}/apis/orgchartAdd.php`,
//             {
//                 method: "POST",
//                 body: formData,
//                 credentials: "include"
//             }
//         );

//         const result = await response.json();

//         if (
//             result.status === "success" &&
//             Array.isArray(result.data)
//         ) {
//             return result.data;
//         } else {
//             return []; // always return array           
//         }
//     } catch (err) {
//         console.error("Fetch Error:", err);
//         return [];
//     }
// };


import { BASE_API } from "../Config/Config";
import { authenticatedFetch } from "./fetchprivateapi";

export const fetchorgchartaddapi = async (data, type) => {
    try {
        const userDetails = JSON.parse(
            sessionStorage.getItem("userdetails") || "null"
        );

        const formData = new FormData();

        formData.append("parent_id", data?.parentId ?? "");
        formData.append("created_by", userDetails?.id ?? "");
        formData.append("ta_name", data?.name_ta ?? "");
        formData.append("en_name", data?.name_en ?? "");
        formData.append("type", type ?? "");

        if (type === "managementOrgchart") {
            formData.append("en_role", data?.position_en ?? "");
            formData.append("ta_role", data?.position_ta ?? "");
        }

        const response = await authenticatedFetch(
            `${BASE_API}/apis/orgchartAdd.php`,
            {
                method: "POST",
                body: formData
            }
        );

        if (!response) return [];

        const result = await response.json();

        if (
            response.ok &&
            result.status === "success" &&
            Array.isArray(result.data)
        ) {
            return result.data;
        }

        return [];

    } catch (err) {
        console.error("Organization Chart Add Error:", err);
        return [];
    }
};
